import React from "react";
import classNames from "classnames";

import styles from "./styles.scss";

const EMPTY_LIST: React.ReactNode[] = [];

export interface IErrorListProps {
  errors?: React.ReactNode[];
  onErrorVisibleChange?: (visible: boolean) => void;
  prefixCls?: string;
  status?: string;
}

export const ErrorList = ({ errors = EMPTY_LIST, prefixCls, status }: IErrorListProps): JSX.Element | null => {
  const [innerStatus, setInnerStatus] = React.useState(status);

  const baseClassName = `${prefixCls}-item-explain`;

  React.useEffect(() => {
    if (status) {
      setInnerStatus(status);
    }
  }, [status]);

  if (errors.length === 0) {
    return null;
  }
  return (
    <div
      className={classNames(styles[baseClassName], {
        [styles[`${baseClassName}-${innerStatus}`]]: innerStatus,
      })}
      key="help"
    >
      {errors.map((error, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} role="alert">
          {error}
        </div>
      ))}
    </div>
  );
};
